import React, { useState } from 'react'
import {
  GoogleMap,
  Marker,
  LoadScript,
  MarkerClusterer,
} from '@react-google-maps/api'
import { ChargeLocationItem, ChargeLocationProps } from './type'

const containerStyle: React.CSSProperties = {
  width: '100%',
  height: '100vh',
}

const clusterStyles: ClusterIconStyle[] = [
  {
    textColor: '#FFFFFF',
    url: 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/mc-pin-icon1.png',
    height: 60,
    width: 60,
    textSize: 16,
  },
]

const clustererOptions: MarkerClustererOptions = {
  styles: clusterStyles,
}

const Map: React.FunctionComponent<
  ChargeLocationProps & {
    onMarkerSelect: (marker: ChargeLocationItem, index: number) => void
    center: { lat: number; lng: number }
    mapRef: React.MutableRefObject<google.maps.Map | null>
    setMarkerInfo: React.Dispatch<
      React.SetStateAction<ChargeLocationItem | null>
    >
    activeMarker: number
  }
> = ({
  apiKey,
  data,
  onMarkerSelect,
  center,
  mapRef,
  setMarkerInfo,
  activeMarker,
}) => {
  const [selectedMarker, setSelectedMarker] = useState(-1)
  const handleMarkerClick = (marker: ChargeLocationItem, index: number) => {
    if (mapRef.current) {
      const newCenter = {
        lat: Number(marker.lat),
        lng: Number(marker.lng),
      }
      mapRef.current.panTo(newCenter)
      mapRef.current.setZoom(15)
      onMarkerSelect(marker, index)

      if (selectedMarker === index) {
        setSelectedMarker(-1)
        setMarkerInfo(null)
      } else {
        setSelectedMarker(index)
        setMarkerInfo(marker)
      }
    }
  }

  const getMarkerOptions = (marker: ChargeLocationItem, index: number) => {
    const isSelected = activeMarker === index
    const isAC = marker.chargingType.title === 'AC'
    let markerUrl

    if (isAC) {
      markerUrl = isSelected
        ? 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/map-pin-blue-selected.svg'
        : 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/map-pin-blue.svg'
    } else {
      markerUrl = isSelected
        ? 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/map-pin-dc-selected.svg'
        : 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/map-pin-dc.svg'
    }

    const markerOptions = {
      icon: {
        url: markerUrl,
        scaledSize: isSelected
          ? new window.google.maps.Size(72, 48)
          : new window.google.maps.Size(58, 36),
      },
    }

    return markerOptions
  }

  if (!apiKey) {
    return <>API Key giriniz...</>
  } else {
    return (
      <LoadScript googleMapsApiKey={apiKey}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={6}
          onLoad={(map) => {
            mapRef.current = map
          }}
        >
          <MarkerClusterer options={clustererOptions}>
            {(clusterer) => (
              <>
                {data?.map((marker, index) => (
                  <Marker
                    key={index}
                    position={{
                      lat: Number(marker.lat),
                      lng: Number(marker.lng),
                    }}
                    clusterer={clusterer}
                    options={getMarkerOptions(marker, index)}
                    onClick={() => handleMarkerClick(marker, index)}
                  />
                ))}
              </>
            )}
          </MarkerClusterer>
        </GoogleMap>
      </LoadScript>
    )
  }
}

export default Map
